import '../../../scss/check.scss'

export function PromptAccess({ fnClose, fnAccept }) {
	const confirmFn = () => {
		const checkbox = document.getElementById('agreementCheckbox')
		if (!checkbox.checked) {
			confirmBtn.classList.add('invalid')
			checkbox.classList.add('invalid')
			setTimeout(() => {
				confirmBtn.classList.remove('invalid')
				checkbox.classList.remove('invalid')
			}, 1000)
		} else {
			fnAccept()
		}
	}

	return (
		<div className='container container_prompt'>
			<header>
				<div className='wrapper'>
					<a href='/'>
						<img src='../images/logo_check.svg' alt='zic logo' />
					</a>
				</div>
			</header>
			<main>
				<section className='formWrapper'>
					<div className='wrapperSecondary'>
						<div id='step_1' className='main_block--info'>
							<h1>
								Приветствуем Вас
								<br />
								на портале ZIC ПРОФИ!
							</h1>
							<p>
								Сообщаем, что в связи с передачей обработки персональных данных
								новому Оператору, с 01 мая 2025 года оператором Ваших
								персональных данных становится ООО «СБУБНОМ» (ИНН 7714497341,
								ОГРН 1227700782561, 125124, Г.Москва, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ
								ОКРУГ БЕГОВОЙ, УЛ 5-Я ЯМСКОГО ПОЛЯ, Д. 27, ПОМЕЩ. I, КОМ. 3)
							</p>
							<p>
								Цели и условия обработки Ваших персональных данных остаются
								прежними. Вы вправе в любой момент отозвать своё согласие на
								обработку персональных данных, направив письменный отзыв по
								адресу, указанному в Политике конфиденциальности.
							</p>
							<div className='confirm_block'>
								<div>
									<div className='check_block'>
										<input
											type='checkbox'
											id='agreementCheckbox'
											className='custom-checkbox'
										/>
										<label htmlFor='agreementCheckbox'>
											Я ознакомлен(а) с{' '}
											<a href='/docs/policy.pdf' target='_blank'>
												Политикой конфиденциальности
											</a>
											и согласен(сна) на обработку моих персональных данных
										</label>
									</div>
									<div onClick={() => confirmFn()} id='confirmBtn'>
										Продолжить
									</div>
								</div>
								<div>
									<div className='check_block'>
										<label htmlFor='canselCheckbox'>
											Я не согласен с изменениями Политикой конфиденциальности
										</label>
									</div>
									<div onClick={() => fnClose()} id='cancelBtn'>
										Покинуть портал
									</div>
								</div>
							</div>
							<p style={{ marginBottom: '0px' }}>
								Благодарим за доверие, желаем успешных продаж!
							</p>
						</div>
					</div>
				</section>
			</main>
			<footer className='footer_new'>
				<p>© 2025 Смазочные материалы торговой марки ООО «СК Энмув Рус»</p>
				<p>
					<a href='https://zictop.ru/docs/policy.pdf' target='_blank'>
						Политика конфиденциальности
					</a>
					<span> | </span>
					<a href='https://zicoil.ru/' target='_blank'>
						Перейти на основной сайт
					</a>
				</p>
			</footer>
		</div>
	)
}
